<template>
    <CContainer class="d-flex content-center min-vh-100">
        <CRow>
            <CCol>
                <CCardGroup>
                    <CCard class="p-3" style="width: 300px">
                        <CCardBody>
                            <CForm @submit.prevent="login" class="text-left">
                                <h4>Thông tin đăng nhập</h4>
                                <br />
                                <!--<p class="text-muted">Thông tin đăng nhập</p>-->
                                <!--<CInput placeholder="Tên tài khoản" v-model="username"
                                        autocomplete="username email">
                                    <template #prepend-content>
                                        <CIcon name="cil-user" />
                                    </template>
                                </CInput>
                                <CInput placeholder="Mật khẩu" v-model="password"
                                        type="password"
                                        autocomplete="curent-password">
                                    <template #prepend-content>
                                        <CIcon name="cil-lock-locked" />
                                    </template>
                                </CInput>-->
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend><b-input-group-text><CIcon name="cil-user" /></i></b-input-group-text></b-input-group-prepend>
                                    <b-form-input type="text" class="form-control" placeholder="Username" v-model="$v.username.$model" :state="$v.username.$dirty ? !$v.username.$error : null"></b-form-input>
                                    <b-form-invalid-feedback>
                                        Please enter username
                                    </b-form-invalid-feedback>
                                </b-input-group>
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend><b-input-group-text><CIcon name="cil-lock-locked" /></i></b-input-group-text></b-input-group-prepend>
                                    <b-form-input type="password" class="form-control" placeholder="Password" v-model="$v.password.$model" :state="$v.password.$dirty ? !$v.password.$error : null"></b-form-input>
                                    <b-form-invalid-feedback>
                                        Please enter password
                                    </b-form-invalid-feedback>
                                    <div class="invalid-feedback" v-show="errorMsg" style="display: block">
                                        {{errorMsg}}
                                    </div>
                                </b-input-group>
                                <CRow>
                                    <CCol col="12" class="text-center">
                                        <CButton color="primary" class="px-4" type="submit">Đăng nhập</CButton>
                                    </CCol>
                                    <!--<CCol col="6" class="text-right">
                                        <CButton color="link" class="px-0">Forgot password?</CButton>
                                        <CButton color="link" class="d-md-none">Register now!</CButton>
                                    </CCol>-->
                                </CRow>
                            </CForm>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </CCol>
        </CRow>
    </CContainer>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'Login',
        mixins: [validationMixin],
        data() {
            return {
                username: null,
                password: null,
                errorMsg: null,
            };
        },
        validations: {
            username: {
                required
            },
            password: {
                required,
            }
        },
        methods: {
            login() {
                this.errorMsg = null;
                this.$v.$touch();
                var vm = this;
                if (!vm.$v.$invalid) {
                    this.$store.dispatch("authenticate", { username: this.username, password: this.password })
                        .done(() => vm.$router.push({ path: '/' }))
                        .fail(function (errors) {
                            if (errors.responseJSON && errors.responseJSON.error_description) {
                                vm.errorMsg = errors.responseJSON.error_description;
                            } else {
                                vm.errorMsg = errors.responseText || errors.statusText;
                            }
                        });
                }
            }
        }
    }
</script>
